import { z } from 'zod'

/** The saved record shared by conversation citations and independent table evidence. */
export const DocketRecordSchema = z.object({
  source: z.object({
    record_kind: z.string(),
    title: z.string(),
    court: z.string().nullable(),
    docket_key: z.string().nullable(),
    provider_last_updated: z.string().nullable(),
    retrieved_at: z.string().datetime({ offset: true }),
  }),
  support: z.object({ summary: z.string(), selected_sentences: z.array(z.string()) }),
})
export type DocketRecord = z.infer<typeof DocketRecordSchema>
